import { IBillingAriaStatus } from "@core/models";
import { BILLING_ARIA_STATUS_TYPES } from "@core/constants";

export const BillingAriaFiltersMock = {
  [BILLING_ARIA_STATUS_TYPES.BILLING_SESSION]: {
    title: "Statuts BS",
    statuses: [
      {
        [IBillingAriaStatus.code]: "draft",
        [IBillingAriaStatus.color]: "primary",
        [IBillingAriaStatus.label]: "Brouillon",
      },
    ],
  },
  [BILLING_ARIA_STATUS_TYPES.ARIA]: {
    title: "Statuts ARIA",
    statuses: [
      {
        [IBillingAriaStatus.code]: "draft",
        [IBillingAriaStatus.color]: "primary",
        [IBillingAriaStatus.label]: "Brouillon",
      },
    ],
  },
  [BILLING_ARIA_STATUS_TYPES.STRIPE]: {
    title: "Statuts Stripe",
    statuses: [
      {
        [IBillingAriaStatus.code]: "in_progress",
        [IBillingAriaStatus.color]: "primary",
        [IBillingAriaStatus.label]: "Brouillon",
      },
    ],
  },
  [BILLING_ARIA_STATUS_TYPES.PAYMENT_TYPES]: {
    title: "Types de paiement",
    statuses: [
      {
        [IBillingAriaStatus.code]: "sepa_debit",
        [IBillingAriaStatus.color]: "primary",
        [IBillingAriaStatus.label]: "Prélèvement",
      },
      {
        [IBillingAriaStatus.code]: "bank_transfer",
        [IBillingAriaStatus.color]: "primary",
        [IBillingAriaStatus.label]: "Virement",
      },
    ],
  },
};
